import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { reportErrors, sandboxPass } from "@unfaithful/client";
import { App } from "./App";
import { armPhoneSound } from "./sound";
import "./styles.css";

reportErrors("phone");
// Keep the sandbox pass on this device (see rememberPass).
void sandboxPass();
armPhoneSound();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
